import { GiCoffeeBeans } from "react-icons/gi";

export const renderContent = (content) => {
    const lines = content.split("\n");

    return (
        <div className="space-y-2 whitespace-pre-line">
            {lines.map((line, index) => {
                const trimmed = line.trim();

                // Bullet line
                if (trimmed.startsWith("•")) {
                    return (
                        <ul key={index} className="pr-4">
                            <li className="flex items-start gap-2 text-stone-800">
                                <GiCoffeeBeans className="text-amber-900 mt-1 shrink-0" />
                                <span>{trimmed.replace("•", "").trim()}</span>
                            </li>
                        </ul>
                    );
                }

                // Empty line → spacing only
                if (trimmed === "") {
                    return <div key={index} className="h-1" />;
                }

                // Normal paragraph
                return (
                    <p key={index}>
                        {line}
                    </p>
                );
            })}
        </div>
    );
};
